<sd-form checkbox
  #checkboxStore
  [brand]="brand"
  [id]="storeFilterUUID"
  (change)="onFilterChange($event)"
  [theme]="filter.theme ? filter.theme : themesEnum.dark"
  [labelTitle]="filter.labelTitle"
  [checked]="filter.state"
  [nameField]="filter.nameField"
  [required]="false"
  [disabled]="filter.disabled"
/>
